<template>
<section>
  <social-header v-if="currentEnv" title="保险代理人认证"></social-header>
<!--代理人认证-->
	<div class="identification">
        <p class="identification-tips" v-if="insureInfo!==null&&insureInfo.auditState===10">{{insureInfo.reason}}</p>
        <div class="identification-agent">
            <h3>成为认证保险代理人</h3>
            <h4>若您已在其他平台获得保险代理人资格证，请上传您的证件照片进行认证（图片不超过5M，拍摄清晰无反光）</h4>
            <div class="identification-agent-upload" v-if="certificateImages.length===0">
			    	<div class="identification_photo-col">
                    <a href="javascript:;" v-on:click="choose()" v-stat:click="{name:'insure_choose'}">
                        <div>
                            <img v-if="!choosed" src="https://dealer2.autoimg.cn/dealerdfs/g26/M09/D3/B1/autohomedealer__wKgHHVtFpv6AUd_HAAAvjC7rasE231.png" alt="">
                            <img v-if="choosed" v-bind:src="imgurl" alt="">
                            <p class="identification_photo-camera">
                                <img src="https://dealer2.autoimg.cn/dealerdfs/g28/M07/D2/B6/autohomedealer__wKgHI1tFd4uAcY8WAAAFGjtJqQg541.png" alt="">
                            </p>
                        </div>
                        <p>上传保险代理人资格证</p>
                    </a>
                </div>
            </div>
            <div class="identification-agent-upload" v-if="certificateImages.length>0">
                <div class="identification_photo-col uploaded">
                    <a href="javascript:;"  v-on:click="choose()" v-stat:click="{name:'insure_rechoose'}">
                        <div>
                            <img v-if="!choosed" v-bind:src="certificateImages[0].certificateImage" alt="">
                            <img v-if="choosed" v-bind:src="imgurl" alt="">
                            <p class="identification_photo-camera">
                                <img src="https://dealer2.autoimg.cn/dealerdfs/g28/M07/D2/B6/autohomedealer__wKgHI1tFd4uAcY8WAAAFGjtJqQg541.png" alt="">
                            </p>
                        </div>
                        <p>重新上传</p>
                    </a>
                </div>
            </div>
            <div class="identification-agent-upload">
                <div class="identification_photo-demo">
                    <img src="https://dealer2.autoimg.cn/dealerdfs/g26/M06/D2/A7/autohomedealer__ChcCP1tFd3CAA_B7AACJAGFL4jk961.png" alt="">
                </div>
                <p>保险代理人资格证示例（包括但不限于以上资格证）</p>
            </div>
		    <div class="identification_submit">
                <a class="common-btn blue-big-btn" v-bind:class="{'disabled':submitDisabled}" href="javascript:;" v-on:click="confirm()" v-stat:click="{name:'insure_confirm'}" title="">{{submitText}}</a>
            </div>
            <div class="identification_proto">
                <label><input type="checkbox" v-model="isAgree">我已阅读并同意</label><router-link :to="{path:'/certificate/agreement'}" v-stat:click="{name:'agreement'}" class="font-blue">《个人信息保护声明》</router-link>
            </div>
        </div>
	</div>
	<!--代理人认证-->
  <!--确认弹层-->
	<div class="confirm-pop" v-bind:class="{'fn-hide':confirmHide}">
		<div class="msk"></div>
		<div class="confirm-box">
			<h3>确认提交</h3>
			<p>提交后，审核期间信息不可修改</p>
			<div class="confirm-btns">
				<a class="font-gray" href="javascript:;" v-on:click="confirmHide=true">返回修改</a>
				<a href="javascript:;" v-on:click="submit()" v-stat:click="{name:'insure_submit'}">提交审核</a>
			</div>
		</div>
	</div>
	<!--确认弹层-->
  <social-dialog title="正在加载" category="tips" v-bind:show="dialogShow"></social-dialog>
</section>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import SocialHeader from '../../components/social-header.vue'
  import SocialDialog from '../../components/social-dialog.vue'
  import Environment from '../../service/environment.service.js'
  import Dialog from '../../plugins/dialog.js'
  import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'

  export default {
    components: {
      SocialHeader,
      SocialDialog
    },
    name: 'CertificateInsure',
    data: function () {
      return {
        isAgree: true,
        choosed: false,
        imgurl: '',
        originUrl: '',
        dialogShow: false,
        confirmHide: true
      }
    },
    created: function () {
      var current = this
      changeDocumentTitle('保险代理人认证')
      current.dialogShow = true
      current.$store.dispatch('resetCertificateImages')
      current.$store.dispatch('getCertificateInfo').then(function () {
        current.dialogShow = false
      })
    },
    computed: {
      submitText () {
        let text = '提交审核'
        let insureCertificate = this.certificateInfo.filter(t => t.certificateType === 1)
        if (insureCertificate.length > 0) {
          let info = insureCertificate[0]
          if (info.auditState === 0) {
            text = '审核中'
          } else {
            if (!this.choosed || !this.isAgree) {
              if (info.auditState === 5) {
                text = '认证通过'
              }
            }
          }
        }
        return text
      },
      insureInfo () {
        var current = this
        let insureCertificate = current.certificateInfo.filter(t => t.certificateType === 1)
        if (insureCertificate.length > 0) {
          current.dialogShow = true
          current.$store.dispatch('getCertificateImages', insureCertificate[0].id).then(function () {
            current.dialogShow = false
          })
          return insureCertificate[0]
        }
        return null
      },
      submitDisabled () {
        var current = this
        if (current.insureInfo !== null && current.insureInfo.auditState === 0) {
          return true
        } else {
          return !current.isAgree || !current.choosed
        }
      },
      ...mapGetters({
        certificateInfo: 'certificateInfo',
        certificateImages: 'certificateImages'
      }),
      currentEnv () {
        if (isWeiXin()) {
          return false
        } else if (isDingDing()) {
          return false
        } else {
          return true
        }
      }
    },
    methods: {
      choose () {
        if (this.insureInfo !== null && this.insureInfo.auditState === 0) {

        } else {
          let current = this
      // 选择微信图片
          if (window.entrance.name !== 'wx' && window.entrance.name !== 'mainapp') {
            Dialog.toast({title: '请在微信或主app环境中打开此页面', timeout: 1000})
            return false
          }
          Environment.chooseImage(function (data) {
        // 微信的id或者本地图片的物理地址
            current.originUrl = data.imgId
        // 微信的id（可以直接显示）或者app的base64图片信息
            current.imgurl = data.imgBase64 || data.imgId
            current.choosed = true
          })
        }
      },
      confirm () {
        if (this.insureInfo !== null && this.insureInfo.auditState === 0) {

        } else {
          if (!this.isAgree) {
            Dialog.toast({title: '请阅读并同意《个人信息保护声明》!'})
            return
          }
          if (!this.choosed) {
            Dialog.toast({title: '请上传保险代理人资格证!'})
            return
          }
          this.confirmHide = false
        }
      },
      // 提交
      submit () {
        let current = this
        current.confirmHide = true
        current.dialogShow = true
        Environment.upload(this.originUrl, function (data) {
          let serverId = data.imgId // 返回图片的服务器端ID，只有微信才有
          let imgBase64 = data.imgBase64
          var param = {certificateType: 1, images: [{wxMediaId: serverId, imageBase64: imgBase64}]}
          current.$store.dispatch('certificateSubmit', param).then(function () {
            current.dialogShow = false
            current.choosed = false
          })
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/certificate/insure.vue